export default __webpack_public_path__ + "static/visit-geomaps-14650fbb12a61d7d1e5905636a2c88a6.jpg";